import type { ConfirmationRequest } from '@/hooks/use-agent-chat.hook';
import { replySubject } from './one-off-send.util';

/** Clu's reply in an Inbox conversation, confirmed on its card. */
export const REPLY_IN_THREAD_ACTION = 'reply_in_thread';

function text(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * The reply a card asks to send, as the server stored it: From, To, the
 * conversation's subject and the reply. Read only. Null for any other card.
 */
export function ReplyInThreadPreview({
  request,
}: {
  request: ConfirmationRequest;
}) {
  if (request.tool_name !== REPLY_IN_THREAD_ACTION) return null;
  const args = request.arguments ?? {};
  const rows = (
    [
      ['From', text(args.from_email)],
      ['To', text(args.to_email)],
      ['Subject', replySubject(text(args.subject))],
    ] as [string, string][]
  ).filter(([, value]) => value);
  const body = typeof args.body === 'string' ? args.body : '';
  return (
    <div
      className='overflow-hidden rounded-[8px] border border-border bg-background text-[12px] leading-[16px]'
      data-testid='reply-in-thread-preview'
    >
      {rows.length > 0 && (
        <dl className='grid grid-cols-[auto_minmax(0,1fr)] gap-x-[12px] gap-y-[4px] border-b border-border px-[10px] py-[8px]'>
          {rows.map(([label, value]) => (
            <div key={label} className='contents'>
              <dt className='text-muted-foreground'>{label}</dt>
              <dd className='min-w-0 font-medium break-words text-foreground'>
                {value}
              </dd>
            </div>
          ))}
        </dl>
      )}
      <div
        data-testid='reply-in-thread-body'
        className='max-h-[240px] overflow-y-auto px-[10px] py-[8px] break-words whitespace-pre-wrap text-foreground'
      >
        {body}
      </div>
    </div>
  );
}
